/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_Free_ForeverInputs */

const en_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free forever`)
};

const es_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis para siempre`)
};

const fr_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratuit pour toujours`)
};

const de_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Für immer kostenlos`)
};

const ja_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`永久無料`)
};

const zh_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`永久免费`)
};

const ar_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مجاني للأبد`)
};

const id_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis selamanya`)
};

const it_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis per sempre`)
};

const ru_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Навсегда бесплатно`)
};

const pt_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grátis para sempre`)
};

const ko_pricing_free_forever = /** @type {(inputs: Pricing_Free_ForeverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`평생 무료`)
};

/**
* | output |
* | --- |
* | "Free forever" |
*
* @param {Pricing_Free_ForeverInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const pricing_free_forever = /** @type {((inputs?: Pricing_Free_ForeverInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_Free_ForeverInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pricing_free_forever(inputs)
	if (locale === "es") return es_pricing_free_forever(inputs)
	if (locale === "fr") return fr_pricing_free_forever(inputs)
	if (locale === "de") return de_pricing_free_forever(inputs)
	if (locale === "ja") return ja_pricing_free_forever(inputs)
	if (locale === "zh") return zh_pricing_free_forever(inputs)
	if (locale === "ar") return ar_pricing_free_forever(inputs)
	if (locale === "id") return id_pricing_free_forever(inputs)
	if (locale === "it") return it_pricing_free_forever(inputs)
	if (locale === "ru") return ru_pricing_free_forever(inputs)
	if (locale === "pt") return pt_pricing_free_forever(inputs)
	return ko_pricing_free_forever(inputs)
});